if (window.innerWidth < 481) {
  
  $(".contentCustomPageAACStep1 .form1 #inputstylecheckboxC").click(function() {
	  $(".contentCustomPageAACStep1 .form1").addClass("activenoshow");
	  $(".contentCustomPageAACStep1 .form2").addClass("activeshow");
  });
  $(".contentCustomPageAACStep1 .form2 #inputstylecheckboxC").click(function() {
	  $(".contentCustomPageAACStep1 .form1").addClass("activenoshow");
	  $(".contentCustomPageAACStep1 .form2").removeClass("activeshow");
	  $(".contentCustomPageAACStep1 .form3").addClass("activeshow");
  });



  $(".contentCustomPageAACStep2 .form1 #inputstylecheckboxC").click(function() {
	  $(".contentCustomPageAACStep2 .form1").addClass("activenoshow");
	  $(".contentCustomPageAACStep2 .form2").addClass("activeshow");
  });

  

  $(".contentCustomPageAACStep3 .form1 #inputstylecheckboxC").click(function() {
	  $(".contentCustomPageAACStep3 .form1").addClass("activenoshow");
	  $(".contentCustomPageAACStep3 .form2").addClass("activeshow");
  });


  
  $(".contentCustomPageAACStep4 .form1 #inputstyleselectC.inputstyleselect").on('change', function() {
	  $(".contentCustomPageAACStep4 .form1").addClass("activenoshow");
	  $(".contentCustomPageAACStep4 .form2").addClass("activeshow");
  });
  $(".contentCustomPageAACStep4 .form2 #inputstyleselectC.inputstyleselect").on('change', function() {
	  $(".contentCustomPageAACStep4 .form1").addClass("activenoshow");
	  $(".contentCustomPageAACStep4 .form2").removeClass("activeshow");
	  $(".contentCustomPageAACStep4 .form3").addClass("activeshow");
  });


  
  $(".contentCustomPageAACStep6 .form1 #inputstylecheckboxC").click(function() {
	  $(".contentCustomPageAACStep6 .form1").addClass("activenoshow");
	  $(".contentCustomPageAACStep6 .form2").addClass("activeshow");
  });
  
}
